import { Component, EventEmitter, HostListener, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom, Subscription } from 'rxjs';
import { PaymentService } from 'src/app/services/Operations/paymentService.service';
import { VendorService } from 'src/app/services/Operations/Vendor.service';
import Swal from 'sweetalert2';
import { customCurrencyPipe } from '../../customCurrency.pipe';
import { ECreditCards, EPaymentGateway, EPaymentModes, EPaymentTransactionType } from '../../enum';
import { environment } from 'src/environments/environment';
import { StripeTerminalSignalRService } from 'src/app/services/stripe-terminal-signal-r.service';
declare var Stripe: any;

@Component({
  selector: 'app-stripe-payment',
  templateUrl: './stripe-payment.component.html',
  styleUrls: ['./stripe-payment.component.scss']
})

export class StripePaymentComponent implements OnInit {
  elements;
  @Input() module;
  @Input() stripeClientSecret;
  @Input() mandatoryFieldsList = [];
  @Input() PublishableKey;
  @Input() UnifiedAccountId;
  @Input() paymentMode = 0;
  @Input() CCAmount;
  @Input() VendorId;
  @Input() keyedInTransaction;
  @Input() TransactionType;
  @Input() shopperRequest;
  @Input() shopperInfo;
  @Input() enableAddressAutofill: boolean;
  @Input() voidPayment;
  @Input() VerifoneId;
  @Input() RefundAmount;
  @Input() ForceCreditReturn;
  @Output() emitStripeModalClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitConfirmaTokenResponse: EventEmitter<any> = new EventEmitter<any>();
  @Output() loaderStatus: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() ClosePaymentPage = new EventEmitter<any>();
  @Output() PaymentResponse = new EventEmitter<any>();
  @Input() isPaymentWithAutoPay;
  @Input() MarketId: number;
  @Input() paymentGateway: number;
  showLoaderMesage = false;
  paymentModeText = '';
  paymentFailReason;
  isSaveInCCTResponse;
  tempCNPPayId = null;
  tempCNPAmount = null;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };

  customerInfo = {
    FirstName: '',
    MiddleName: '',
    LastName: '',
    CompanyName: '',
    AddressOne: '',
    City: '',
    CountryCode: '',
    StateCode: '',
    StateId: 0,
    PostalCode: '',
    CountryId: 0,
    CellPhoneNumber: '',
    Email: '',
    FullName: '',
    VendorIdd: 0
  }
  mandateId = '';
  payStatus: string;
  paymentSuccessFul: boolean;
  paymentTable = [];
  paymentCount;
  paymentStarted = false;
  paymentInProgress = false;
  isPaymentCancelled = false;
  paymentProcessing = false;
  currentPayId;
  defaultmode: number;
  submitButtonName: string = '';
  isDisableSubmit: boolean = false;
  isPaymentFormComplete: boolean = false;
  public loaderIcon: Promise<boolean>;
  requestgatewaydetails;
  selectedDeviceId = 0;
  verifoneRecordId = 0;
  vendorInfo;
  credentials;
  tillNowPaid = 0;
  MASKEDCARDNUMBER = '';
  initiatedVoidCC = false;
  private paymentMaxWaitTime = 2;//environment.paymentMaxWaitTime;
  stripeTerminalDeviceId: any;
  isStripeTerminalPay = false;
  stripeResponse: any;
  private baseUrl = environment.apiBaseUrl;
  private stripeResponseSubscription: Subscription;
  autopayLinledUnitList = [];
  AutoPopulateBillingInfoMsg: string = 'Auto Populate Customer Information';

  //added for CountDown Timer 
  paymentCountdown: string = '0';
  CountdownS: number = 0;
  CurrencyCCAmount: string = "";
  private stripe3ds: any;
  private countdownTimerId: any;
  checkingPaymentStatus: boolean = false;
  constructor(private paymentService: PaymentService, private vendorService: VendorService,
    private renderer: Renderer2, private customCurrency: customCurrencyPipe,
    private toastr: ToastrService, private signalRService: StripeTerminalSignalRService,
  ) { }

  ngOnInit(): void {
    this.CurrencyCCAmount = this.customCurrency.transform(this.CCAmount);
    this.paymentCount = 0;
    this.paymentTable = [];
    this.paymentCount++;
    const obj = {
      payId: this.paymentCount,
      payName: 'Payment ' + this.paymentCount,
      payAmount: this.CCAmount,
      payComplete: false,
      payNowDisable: true,
      payModeId: 0,
      orderId: null,
      changeAmount: 0,
      checkNum: 0,
      checkDate: '',
      bankName: '',
      ManualCardNumber: '',
      ManualCardExp: '',
      ManualCardName: '',
      CreditCardType: 0,
      ManualCardAuthorization: '',
      defaultmode: 0,
      uniqueTransId: null,
      payFailed: false,
      routingNumber: 0,
      accountNumber: 0,
      achManualCardAuthorization: '',
      accountType: 279,
      nameonAccount: '',
      isOpenEdgePaymentCompleted: false,
      remotePayIsSMS: false,
      remotePayPhoneNumber: '',
      remotePayIsEmail: false,
      remotePayEmailId: '',
      stripePaymentIntentId: 0,
      EnableAutopayOrCardOnFile: 'cancel',
      TerminalDeviceId: ''
    };
    this.paymentTable.push(obj);

    this.getVendorInfo();
    this.getCredentials();

    if (this.paymentMode == EPaymentModes.ACH) {
      this.paymentModeText = 'ACH Payment';
    } else if (this.paymentMode == EPaymentModes.DirectDebitEFT) {
      this.paymentModeText = 'EFT Payment';
    } else if (this.keyedInTransaction) {
      this.paymentModeText = 'Hosted Page Payment';
    } else if (!this.keyedInTransaction) {
      this.paymentModeText = 'Device Payment';
    }
    this.submitButtonName = this.module == 2 && !this.isPaymentWithAutoPay ? 'Set Autopay' : 'Make Payment';
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: BeforeUnloadEvent) {
    const payment = this.paymentTable?.find(o => o.payId === this.currentPayId);
    if (payment && !payment.isOpenEdgePaymentCompleted) {
      const obj = {
        MarketId: this.MarketId ?? null,
        PaymentIntentId: payment.stripePaymentIntentId ?? '',
        DeviceId: payment.TerminalDeviceId ?? '',
        OrderId: payment.orderId ?? 0,
        VerifoneId: this.verifoneRecordId ?? 0,
        VendorId: this.customerInfo?.VendorIdd ?? 0,
        keyedInTransaction: this.keyedInTransaction ?? false,
        shopperRequest: this.shopperRequest
      };
      localStorage.setItem('StripeCancelPaymentReq', JSON.stringify(obj));
    }
  }

  async getVendorInfo() {
    // Shopper requests have no vendor record, so populate billing info from the shopper passed in.
    if (this.shopperRequest && this.shopperInfo) {
      this.setShopperInfo();
      return;
    }
    const res = await lastValueFrom(
      this.vendorService.GetVendorById(this.VendorId)
    );
    if (res !== null) {
      this.AutoPopulateBillingInfoMsg = "Auto Populate Vendor Information";
      this.vendorInfo = res.body;
      this.customerInfo.FirstName = this.vendorInfo.FirstName ? this.vendorInfo.FirstName : "";
      this.customerInfo.MiddleName = this.vendorInfo.MiddleName ? this.vendorInfo.MiddleName : "";
      this.customerInfo.LastName = this.vendorInfo.LastName ? this.vendorInfo.LastName : "";
      this.customerInfo.CompanyName = this.vendorInfo.CompanyName ? this.vendorInfo.CompanyName : "";
      this.customerInfo.AddressOne = this.vendorInfo.Address ? this.vendorInfo.Address : "";
      this.customerInfo.City = this.vendorInfo.City ? this.vendorInfo.City : "";
      this.customerInfo.CountryCode = this.vendorInfo.Country ? this.vendorInfo.Country : "";
      this.customerInfo.StateCode = this.vendorInfo.DLState ? this.vendorInfo.DLState : "";
      this.customerInfo.StateId = this.vendorInfo.State ? this.vendorInfo.State : 0;
      this.customerInfo.PostalCode = this.vendorInfo.ZipCode ? this.vendorInfo.ZipCode : "";
      this.customerInfo.CountryId = this.vendorInfo.CountryCode ? this.vendorInfo.CountryCode : 0;
      this.customerInfo.CellPhoneNumber = this.vendorInfo.CellPhone ? this.vendorInfo.CellPhone : "";
      this.customerInfo.Email = this.vendorInfo.Email ? this.vendorInfo.Email : "";
      this.customerInfo.FullName = this.vendorInfo.VendorName ? this.vendorInfo.VendorName : "";
      this.customerInfo.VendorIdd = this.vendorInfo.VendorId ? this.vendorInfo.VendorId : 0;
      this.MarketId = this.vendorInfo.MarketId;
    }
  }

  setShopperInfo() {
    this.AutoPopulateBillingInfoMsg = "Auto Populate Shopper Information";
    const shopper = this.shopperInfo;
    this.customerInfo.FirstName = shopper.ShopperName ? shopper.ShopperName : "";
    this.customerInfo.MiddleName = "";
    this.customerInfo.LastName = "";
    this.customerInfo.CompanyName = "";
    this.customerInfo.AddressOne = shopper.Address ? shopper.Address : "";
    this.customerInfo.City = shopper.City ? shopper.City : "";
    this.customerInfo.CountryCode = shopper.Country ? shopper.Country : "";
    this.customerInfo.StateCode = shopper.StateCode ? shopper.StateCode : "";
    this.customerInfo.StateId = 0;
    this.customerInfo.PostalCode = shopper.ZipCode ? shopper.ZipCode : "";
    this.customerInfo.CountryId = shopper.CountryId ? shopper.CountryId : 0;
    this.customerInfo.CellPhoneNumber = shopper.Phone ? shopper.Phone : "";
    this.customerInfo.Email = shopper.Email ? shopper.Email : "";
    this.customerInfo.FullName = shopper.ShopperName ? shopper.ShopperName : "";
    this.customerInfo.VendorIdd = 0;
  }

  getCredentials() {
    this.paymentService.getCCCredentials().subscribe((res) => {
      if (res !== null) {

        this.paymentGateway = res.PaymentGateWay;
        this.MarketId = res.MarketId;
        this.credentials = res.GatewayDetails ? JSON.parse(res.GatewayDetails) : null;
        if (this.voidPayment == true) {
          this.voidPaymentTransaction(this.VerifoneId, this.credentials);
        }
        else {
          this.initiatePaymentRequest();
        }
      }
    })
  }

  async initiatePaymentRequest() {
    this.paymentStarted = true;
    const amount = this.CCAmount;
    const payId = 1;
    this.currentPayId = payId;
    this.stripeClientSecret = this.credentials.SecretKey;
    this.PublishableKey = this.credentials.PublishableKey;
    this.UnifiedAccountId = this.credentials.AccountID;

    if (!this.keyedInTransaction) {
      const terminalDevices = await lastValueFrom(
        this.paymentService.GetTerminalDevices(EPaymentGateway.Stripe)
      );
      if (terminalDevices !== null) {
        this.credentials["DeviceSettings"] = terminalDevices;
      }
      //this.credentials["DeviceSettings"] = [{ TerminalReaderId: "tmr_GlWFcgcxNBR4fQ", Devices: "BLR_Stripe", Primary:true }];
      const deviceOptions = this.credentials.DeviceSettings.reduce((options, device) => {
        options[device.TerminalReaderId] = `${device.Devices}`;
        return options;
      }, {} as Record<string, string>);

      const result = await Swal.fire({
        title: "Select a Terminal Device", input: "select",
        inputOptions: deviceOptions, inputPlaceholder: "Select a Terminal Device",
        showCancelButton: true, confirmButtonText: "Continue",
        cancelButtonText: "Cancel", allowOutsideClick: false, allowEscapeKey: false,
        inputValue: this.credentials.DeviceSettings.find(o => o.Primary == true).TerminalReaderId,
        inputValidator: (value) => {
          return value ? null : "Please select a Terminal Device.";
        }
      });
      if (result.isDismissed) {
        this.gotoPaymentSuccess(0);
      }
      if (result.value) {
        this.stripeTerminalDeviceId = result.value;
        this.saveInVerifoneUnsaved(amount, payId);
      }
    }
    else if (this.keyedInTransaction) {
      this.saveInVerifoneUnsaved(amount, payId);
    }
  }

  saveInVerifoneUnsaved(amount, payId) {
    this.paymentFailReason = '';
    let CCTModel = this.generateIntialCCT(this.CCAmount, 1, 1, 1, null, null, null, null);
    this.paymentService.saveVerifoneUnSaved(CCTModel).subscribe((cctRes) => {
      if (cctRes.Success) {
        let cctId = cctRes.Id;
        this.verifoneRecordId = cctRes.Id;
        this.paymentTable.find(o => o.payId == payId).orderId = cctRes.OrderId;
        this.paymentTable.find(o => o.payId == payId).uniqueTransId = cctRes.Id;
        this.isSaveInCCTResponse = true;
        if (!this.keyedInTransaction) {
          this.paymentTable.find(o => o.payId == payId).TerminalDeviceId = this.stripeTerminalDeviceId;
          this.defaultmode = 3; //Terminal
          this.paymentTable.find(o => o.payId == payId).payModeId = this.defaultmode;
          this.requestgatewaydetails = {
            CompletePaymentDuringDayEnd: 0,//this.credentials.CompletePaymentDuringDayEnd,
            AccountId: this.credentials.AccountID,
            SecretKey: this.credentials.SecretKey,
            ReaderId: this.paymentTable.find(o => o.payId === this.currentPayId).TerminalDeviceId
          }
          this.stripeTerminalPayment();

        } else if (this.keyedInTransaction) {
          this.isPaymentWithAutoPay = false;
          this.defaultmode = 5; //Stripe Hosted Page
          this.paymentTable.find(o => o.payId == payId).payModeId = this.defaultmode;
          this.paymentTable.find(o => o.payId == payId).defaultmode = this.defaultmode;
          this.paymentMode = this.defaultmode; //Stripe Hosted Page
          this.tempCNPAmount = amount;
          this.tempCNPPayId = payId;
          this.stripeScript();
        }
      } else {
        this.loaderIcon = Promise.resolve(false);
        this.paymentStarted = false;
        this.toastr.error("We couldn't create CCT, Please try again!", 'Failure', this.toasterConfig);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
      this.paymentStarted = false;
      this.toastr.error(' Something went wrong!', 'Failure', this.toasterConfig);
    });
  }

  generateIntialCCT(amt, transTypeId, ptId, paymentModeId, payvoid, cardNumber, authCode, voidOrderId) {
    let CreditCardNumber = cardNumber ? cardNumber.substr(cardNumber.length - 4) : "";
    const CCTModel = {
      verifoneRecordId: this.verifoneRecordId,
      Amount: amt,
      VendorId: this.VendorId,
      CreditCardNumber: CreditCardNumber,
      CreditCardType: ECreditCards.Visa,
      ResponseCode: "",
      ResponseMessage: "",
      OrderId: voidOrderId ? voidOrderId : "",
      TransactionDateTime: new Date(),
      ProcessStatus: "In progress",
      shopperRequest: this.shopperRequest
    };
    return Object.assign(CCTModel);
  }

  addJsToElement(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  async stripeScript(): Promise<void> {
    this.getPaymentIntent();
    if (this.isEftPayment()) {
      setTimeout(() => {
        if (this.customerInfo?.Email) {
          this.loaderStatus.emit(true);
          this.onStripePay();
        }
      }, 2000);
    }
  }

  getPaymentIntent() {
    const payMode = this.paymentTable.find(o => o.payId === this.currentPayId).payModeId;
    let InputObj = {
      OrderId: this.paymentTable.find(o => o.payId === this.currentPayId).orderId,
      UserId: 0,
      VendorId: this.customerInfo.VendorIdd,
      TransactionType: this.paymentMode,//this.getLovTransactionType(),
      Amount: Math.round(parseFloat(this.CCAmount) * 100),
      MarketId: this.MarketId,
      SelectedPaymentModeType: payMode == EPaymentModes.DirectDebitEFT ? 'EFT' : payMode == EPaymentModes.ACH ? 'ACH' : 'HostedPage',
      cctId: this.paymentTable.find(o => o.payId === this.currentPayId).uniqueTransId,
      SetUpFutureUsage: this.paymentTable.find(o => o.payId === this.currentPayId).EnableAutopayOrCardOnFile == 'cancel' ? null : 'off_session',
      Name: this.customerInfo.FullName,
      Email: this.customerInfo.Email,
      Phone: this.customerInfo.CellPhoneNumber,
      Customer: "", //this.processPayment?.CustomerId ? this.processPayment.CustomerId: this.facOpsDataService?.saveautopay?.CustomerId || '',
      PaymentTransactionType: 2//this.getTransactionType()
    }

    this.paymentService.getPaymentIntent_Stripe(InputObj).subscribe((response: any) => {
      if (this.isPaymentCancelled) {
        // User cancelled before the intent was created - silently cancel the late intent
        if (response?.Success && response.PaymentIntentId) {
          this.paymentService.CancelPaymentIntent(response.PaymentIntentId, this.MarketId).subscribe(() => { }, err => console.error('Error in Cancel Payment Intent', err));
        }
        return;
      }
      if (response && response.Success) {
        this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId = response.PaymentIntentId
        this.stripeClientSecret = response.ClientSecret;

        var stripe = Stripe(this.PublishableKey, { stripeAccount: this.UnifiedAccountId });
        this.stripe3ds = stripe;
        var elements = this.createStripeElements(stripe);
        this.elements = elements;

        this.mountExpressCheckoutElement(elements);
        this.mountPaymentElement(elements);
        if (this.paymentMode == EPaymentModes.HostedPage) {
          this.mountAddressElements(elements);
        }

        const paymentElement = elements.getElement('payment');
        paymentElement.on('change', (event) => {
          this.handlePaymentMethodChange(event, elements);
        });

        const form = document.querySelector("#payment-form");
        form.addEventListener('submit', (event) => this.submitPaymentForm(event, elements, stripe));
      }
      else {
        let errprResponse = {
          Reason: response.Message,
          errprResponse: JSON.stringify(response),
          ResponseCode: ""
        }
        this.saveStripeCCTransactionFail(errprResponse, "", InputObj.OrderId, EPaymentTransactionType.Declined);
        this.loaderIcon = Promise.resolve(false);
      }

    }, err => {
      if (this.isPaymentCancelled) {
        return;
      }
      const errprResponse = this.handelStripeError(err);
      errprResponse.Reason = errprResponse.Reason + " [Errror in Creating PaymentIntent]";
      errprResponse['errprResponse'] = JSON.stringify(err);
      this.saveStripeCCTransactionFail(errprResponse, "", InputObj.OrderId, EPaymentTransactionType.Declined);
      this.loaderIcon = Promise.resolve(false);
    });
  }

  createStripeElements(stripe) {
    const elementOptions = {
      clientSecret: this.stripeClientSecret,
      appearance: {
        theme: 'stripe'
      }
    };
    return stripe.elements(elementOptions);
  }

  mountPaymentElement(elements: any): void {
    const paymentElementOptions = {
      layout: 'tabs',
    };

    var paymentElement = elements.create('payment', {

      defaultValues: {
        billingDetails: {
          name: this.customerInfo ? (this.customerInfo.FirstName + this.customerInfo.MiddleName + this.customerInfo.LastName) : '',
          email: this.customerInfo?.Email ?? '',
        }
      }
    });
    paymentElement.mount('#payment-element');
  }

  mountExpressCheckoutElement(elements: any): void {
    const expressCheckoutContainer = document.getElementById('express-checkout-element');
    if (!expressCheckoutContainer) {
      return;
    }

    try {
      const expressCheckoutElement = elements.create('expressCheckout', {
        paymentMethods: {
          applePay: 'auto',
          googlePay: 'auto',
          amazonPay: 'auto'
        }
      });
      expressCheckoutElement.mount('#express-checkout-element');
    } catch {
      // Keep payment flow working on Stripe versions/accounts without express checkout enabled.
      expressCheckoutContainer.style.display = 'none';
    }
  }

  mountAddressElements(elements) {
    let addressElementOptions = {
      mode: 'billing',
      autocomplete: {
        mode: this.enableAddressAutofill ? 'automatic' : 'disabled'
      },
      fields: {
        name: 'always',
        address: this.credentials?.MandatoryAddressField ? 'always' : 'never',
        phone: 'always',
        email: 'always'
      },
      validation: {
        "name": {
          "required": "always"
        },
        "address": {
          "line1": {
            "required": "always"
          },
          "line2": {
            "required": "never"
          },
          "city": {
            "required": "always"
          },
          "state": {
            "required": "always"
          },
          "postal_code": {
            "required": "always"
          },
          "country": {
            "required": "always"
          }
        },
        "phone": {
          "required": "never"
        },
        "email": {
          "required": "never"
        }
      }
    };
    setTimeout(() => {
      const addressElement = elements.create('address', addressElementOptions);
      addressElement.mount('#address-element');
    }, 500)
  }

  getMandatoryFieldValue(field) {

    if (!this.credentials.MandatoryFieldSettings.length) {
      return 'never';
    }
    else {
      if (this.credentials.MandatoryFieldSettings[field] == true) {
        return 'always'
      }
    }
    return 'never';
  }

  closeStripeForm() {
    this.emitStripeModalClose.emit(true);
    this.loaderIcon = Promise.resolve(false);
    this.isDisableSubmit = false;
  }

  onStripePay() {
    const submitButton = document.getElementById("submit") as HTMLButtonElement;
    if (submitButton) {
      this.loaderIcon = Promise.resolve(true);
      this.isDisableSubmit = true;
      submitButton.click();
      this.loaderStatus.emit(false);
    }
  }

  async submitPaymentForm(event: Event, elements: any, stripe: any) {
    event.preventDefault();
    try {
      const { error: submitError } = await elements.submit();
      if (submitError) {
        this.loaderIcon = Promise.resolve(false);
        this.isDisableSubmit = false;
        this.handleError(submitError);
        return;
      }
      let returnTokenOrPaymentMethod = '';
      let errorData;
      if (this.module == 2) {
        const { setupIntent, error } = await stripe.confirmSetup({
          elements,
          params: {
            payment_method_data: {
              billing_details: {
                name: this.customerInfo.FirstName + this.customerInfo.MiddleName + this.customerInfo.LastName,
                email: this.customerInfo.Email,
              },
            },
          },
          redirect: 'if_required'
        });

        returnTokenOrPaymentMethod = setupIntent;
        errorData = error;
      } else {
        const { error, confirmationToken } = await stripe.createConfirmationToken({
          elements
        });
        returnTokenOrPaymentMethod = confirmationToken;
        errorData = error;
      }
      if (errorData) {
        this.loaderIcon = Promise.resolve(false);
        this.isDisableSubmit = false;
        this.handleError(errorData);
        return;
      }
      this.handlestripeToken(returnTokenOrPaymentMethod);
    } catch (ex) {
      this.loaderIcon = Promise.resolve(false);
      this.isDisableSubmit = false;
      this.handleError(ex);
    }
  }

  handleError(error) {
    const isConnectionError = error?.type === 'api_connection_error'
      || /failed to fetch|network/i.test(error?.message || '');
    const message = isConnectionError
      ? $localize`Unable to reach the payment server. Please check your internet connection and try again.`
      : (error?.message || $localize`Please enter all required fields and valid card details or failed to receive confirmation token`);
    this.toastr.warning(message, 'Payment Error', this.toasterConfig);
    this.loaderIcon = Promise.resolve(false);
  }

  handlestripeToken(confirmationToken) {
    //this.PaymentResponse.emit(confirmationToken);
    this.getConfirmationTokenData(confirmationToken);
  }

  handlePaymentMethodChange(event: any, elements) {
    this.isPaymentFormComplete = !!event.complete;

    if (event.value) {
      try {
        const addressElementContainer = document.getElementById('address-element');
        const addressElement = elements.getElement('address');

        if (event.value.type === 'card') {
          if (addressElementContainer && !addressElementContainer.hasChildNodes()) {
            addressElement.mount('#address-element');
          }
        } else if (addressElement) {
          addressElement.unmount();
        }
      } catch (e) {
        this.loaderIcon = Promise.resolve(false);
      }
    }
  }

  onClickAutoPopulateBillingInfo(checked) {
    let addressElement = this.elements.getElement('address');
    if (checked) {
      if (this.customerInfo) {
        if (addressElement) {
          addressElement.unmount();
          addressElement.destroy(); // Destroy the previous element
        }
        setTimeout(() => {
          const addressElementOptions = this.getAddressElementOptions(false);
          addressElement = this.elements.create('address', addressElementOptions);
          addressElement.mount('#address-element');
        }, 500);
      }
    } else {
      if (addressElement) {
        addressElement.unmount();
        addressElement.destroy();

        setTimeout(() => {
          const addressElementOptions = this.getAddressElementOptions(true);
          addressElement = this.elements.create('address', addressElementOptions);
          addressElement.mount('#address-element');
        }, 500);
      }
    }
  }

  isEftPayment(): boolean {
    return this.paymentMode == EPaymentModes.DirectDebitEFT || this.paymentMode == EPaymentModes.DirectDebitEFTOnFile;
  }

  isAchOrEftPayment(): boolean {
    return this.paymentMode == EPaymentModes.DirectDebitEFT || this.paymentMode == EPaymentModes.ACH || this.paymentMode == EPaymentModes.ACHOnFile || this.paymentMode == EPaymentModes.DirectDebitEFTOnFile;
  }

  isMandatoryAddressField(): boolean {
    return this.credentials?.MandatoryAddressField ? true : false;
  }

  getAddressElementOptions(isClear) {
    if (isClear) {
      return {
        mode: 'billing',
        fields: {
          name: 'always',
          address: 'always',
          phone: 'always',
          email: 'always'
        },
        defaultValues: {
          name: '',
          address: {
            line1: '',
            line2: '',
            city: '',
            state: '',
            postal_code: '',
            country: '',
          }
        }
      };
    } else {
      return {
        mode: 'billing',
        fields: {
          name: 'always',
          address: 'always',
          phone: 'always',
          email: 'always'
        },
        defaultValues: {
          name: [this.customerInfo.FirstName, this.customerInfo.MiddleName, this.customerInfo.LastName].filter(part => !!part).join(' '),
          address: {
            line1: this.customerInfo.AddressOne ?? "",
            line2: '',
            city: this.customerInfo.City ?? "",
            state: this.customerInfo.StateCode ?? "",
            postal_code: this.customerInfo.PostalCode ?? "",
            country: this.customerInfo.CountryCode ?? "",
          },
        }
      };
    }
  }

  getConfirmationTokenData(confirmationTokenInfo) {
    this.paymentInProgress = true;
    this.ConfirmPaymentIntent(confirmationTokenInfo, null);
  }

  onhstPayBtn(val) {
    if (val == 'Cancel') {
      this.isPaymentCancelled = true;
      try {
        this.loaderIcon = Promise.resolve(true);
        let IntentId = this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId;
        let orderId = this.paymentTable.find(o => o.payId === this.currentPayId).OrderId;
        let payModeId = this.paymentTable.find(o => o.payId === this.currentPayId).payModeId;
        let deviceId = this.paymentTable.find(o => o.payId === this.currentPayId).TerminalDeviceId;
        this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
        if (!this.keyedInTransaction) {
          this.paymentService.CancelTerminalAction(deviceId, this.MarketId).subscribe((cancelTerminalActionRes: any) => {
            console.log(cancelTerminalActionRes);
          }, err => {
            this.loaderIcon = Promise.resolve(false);
            this.toastr.error('Error in Cancel Terminal Action', 'Failure', this.toasterConfig);
          });
        }
        const saveCancelledTransaction = (cancelOrRefundRes: any) => {
          let CCTModel;
          const tempCCModel = {
            VerifoneId: this.verifoneRecordId,
            Card: this.keyedInTransaction ? "Credit Card" : " ",
            ResponseCode: '',
            ResponseMessage: cancelOrRefundRes?.Status ?? '',
            ReceiptResponse: JSON.stringify(cancelOrRefundRes ?? {}),
            TransactionDateTime: new Date(),
            OrderId: orderId,
            VendorId: this.VendorId,
            ProcessStatus: "Failed",
            PaymentTransactionTypeId: IntentId == 0 ? "" : IntentId,
            shopperRequest: this.shopperRequest
          };
          CCTModel = Object.assign(tempCCModel);
          this.paymentService.saveVerifoneUnSaved(CCTModel).subscribe((res: any) => {
            this.ClosePaymentPage.emit();
            this.loaderIcon = Promise.resolve(false);
          }, error => {
            this.ClosePaymentPage.emit();
            this.loaderIcon = Promise.resolve(false);
            this.toastr.error('Error in saveVerifoneUnSaved', 'Failure', this.toasterConfig);
          });
        };
        if (!IntentId) {
          // Payment intent was never created, nothing to cancel on Stripe
          saveCancelledTransaction({ Status: 'canceled' });
          return;
        }
        // User cancelled the payment - an uncancelled intent is never charged, so don't show a failure toast
        this.paymentService.CancelPaymentIntent(IntentId, this.MarketId).subscribe((cancelOrRefundRes: any) => {
          saveCancelledTransaction(cancelOrRefundRes);
        }, error => {
          console.error('Error in Cancel Payment Intent', error);
          saveCancelledTransaction({ Status: 'canceled', Message: 'Error in Cancel Payment Intent' });
        });
      } catch (e) {
        this.ClosePaymentPage.emit();
        this.loaderIcon = Promise.resolve(false);
      }
    }
  }

  ConfirmPaymentIntent(confirmationTokenInfo, paymentMethodId) {
    if (this.isPaymentWithAutoPay) {
      //this.loaderIcon = Promise.resolve(true);
      //let selectedPayment = this.paymentTable.find(o => o.payId === this.currentPayId);
      //if (selectedPayment.payModeId !== EPaymentModes.CreditCard && this.stripeModalRef) {
      //  this.stripeModalRef.hide();
      //}
      //let inputObj = {
      //  OrderId: selectedPayment.uniqueTransId,
      //  UserId: this.userSessionService.userSessionData.UserId,
      //  TenantId: this.processPayment.TenantId,
      //  TransactionType: this.getLovTransactionType(),
      //  Amount: parseFloat(this.amountToPay) * 100,
      //  MarketId: this.MarketId,
      //  LeaseNo: this.processPayment.LeaseNo,
      //  PaymentMethod: confirmationTokenInfo.payment_method,
      //  Customer: this.processPayment?.CustomerId ? this.processPayment.CustomerId : this.facOpsDataService?.saveautopay?.CustomerId || '',
      //  PaymentTransactionType: this.getTransactionType(),
      //};
      //let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
      //this.paymentService.processPaymentWithAutopay(inputObj).subscribe((response: any) => {
      //  this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId = response.PaymentIntentId;
      //  this.GetStripeResponse(response, this.currentPayId, this.paymentTable.find(o => o.payId === this.currentPayId).orderId, paymentTrnsId, selectedPayment.payModeId);
      //}, () => {
      //  this.GetStripeResponse(null, this.currentPayId, this.paymentTable.find(o => o.payId === this.currentPayId).orderId, paymentTrnsId, selectedPayment.payModeId);
      //});
    } else {
      let paymentIntentId = this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId;
      let orderId = this.paymentTable.find(o => o.payId === this.currentPayId).orderId;
      let confirmationId = confirmationTokenInfo ? confirmationTokenInfo.id : null
      this.paymentService.ConfirmPaymentIntent(this.MarketId, paymentIntentId, paymentMethodId, confirmationId).subscribe((response: any) => {
        // 3D Secure authentication is required
        if (response && (response.Status === 'requires_action' || response.RequiresAction === true)) {
          this.stripeMethod("", response.ClientSecret);
        }
        else
          if (response && response.Success) {
            if (this.paymentTable.find(o => o.payId === this.currentPayId).payModeId != EPaymentModes.CreditCard) {
              //this.prePayStatus = 'Payment';
              this.GetChargesDetailsByIntentId();
            }
          }
          else {
            let errprResponse = {
              Reason: response.Message,
              errprResponse: JSON.stringify(response),
              ResponseCode: ""
            }
            this.saveStripeCCTransactionFail(errprResponse, "", orderId, EPaymentTransactionType.Declined);
            this.loaderIcon = Promise.resolve(false);
          }
      }, err => {
        if (err?.error?.error) {
          const errprResponse = this.handelStripeError(err);
          errprResponse.Reason = "keyedInTransactionailure";
          errprResponse['errprResponse'] = JSON.stringify(err);
          this.saveStripeCCTransactionFail(errprResponse, "", orderId, EPaymentTransactionType.Declined);
          this.toastr.error(err.error.error, 'FkeyedInTransactionailure', this.toasterConfig);
        } else {
          const errprResponse = this.handelStripeError(err);
          errprResponse.Reason = errprResponse.Reason + " Failed to Confirm Payment Intent (keyedInTransactionailure)";
          errprResponse['errprResponse'] = JSON.stringify(err);
          this.saveStripeCCTransactionFail(errprResponse, "", orderId, EPaymentTransactionType.Declined);
          this.toastr.error('Failed to Confirm Payment Intent', 'Failure', this.toasterConfig);
        }
      });
    }
  }

  GetChargesDetailsByIntentId() {
    let paymentIntentId = this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId;
    let orderId = this.paymentTable.find(o => o.payId == this.currentPayId).orderId;
    let paymentMode = this.paymentTable.find(o => o.payId == this.currentPayId).payModeId;
    let paymentTrnsId = 5;//this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    const obj = {
      PaymentIntentId: paymentIntentId,
      MarketId: this.MarketId,
      PayId: this.currentPayId,
      OrderId: orderId,
      PaymentTrnsId: paymentTrnsId,
      PaymentModeId: paymentMode
    }
    this.callGetStripeCharge(obj);
  }

  async callGetStripeCharge(payDetails, checkTerminalStatus: boolean = false) {
    let stripePaymentTable = this.paymentTable.find(o => o.payId === payDetails.PayId);
    let readerId = stripePaymentTable.payModeId == EPaymentModes.CreditCard ? stripePaymentTable.TerminalDeviceId : "";
    this.paymentService.GetChargesDetailsByIntentId(payDetails.PaymentIntentId, payDetails.MarketId, readerId, checkTerminalStatus).subscribe(async (res: any) => {
      if (res) {
        if (checkTerminalStatus && res.ResponseCode === 'PENDING') {
          // The customer just hasn't finished tapping/inserting their card yet - this was a
          // manual peek, not a real decline, so don't finalize the payment as failed.
          this.checkingPaymentStatus = false;
          this.loaderIcon = Promise.resolve(false);
          this.toastr.info('Payment is still in progress. Please wait for the customer to complete the transaction on the reader.', 'Please wait', this.toasterConfig);
          return;
        }

        this.unSubscribeSignalRSubscribe();
        stripePaymentTable.isOpenEdgePaymentCompleted = true;

        this.mandateId = res.MandateId;
        if (!res.CreditHolderName && payDetails?.NameOnCard) {
          res['CreditHolderName'] = payDetails.NameOnCard;
        }
        if (payDetails.PaymentModeId !== EPaymentModes.CreditCard) {// && this.stripeModalRef) {
          //this.stripeModalRef.hide();
        }
        if (res.Success && stripePaymentTable.EnableAutopayOrCardOnFile != 'cancel') {
          if (payDetails.PaymentModeId == EPaymentModes.CreditCard) {
            //this.paymentAccountId = await this.callGetAutoPayMethod();
            //res['PaymentMethodId'] = this.paymentAccountId;
          }
          //if (this.autopayLinledUnitList.length > 0) {
          //  this.loaderIcon = Promise.resolve(false);
          //  this.stripeResponse = res;
          //  this.linkedAutopayModalRef = this.modalService.show(this.linkedAutopay, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
          //  return;
          //}
        }
        if (payDetails.PaymentModeId == EPaymentModes.CreditCard && res.ResponseCode == '-1' && res.Reason == 'Transaction Time Out!') {
          this.toastr.warning('Please ask Administrator to Reset the Terminal Device', 'Alert', this.toasterConfig);
        }

        this.GetStripeResponse(res, payDetails.PayId, payDetails.OrderId, payDetails.PaymentTrnsId, payDetails.PaymentModeId);
      }
    }, () => {
      if (payDetails.PaymentModeId !== EPaymentModes.CreditCard) {//&& this.stripeModalRef) {
        //this.stripeModalRef.hide();
      }
    });
  }

  async GetStripeResponse(stripeRes, payId, orderId, paymentTrnsId, paymentMode) {
    this.loaderIcon = Promise.resolve(false);
    this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
    if (stripeRes.Success) {
      this.paymentSuccessFul = true;
      this.payStatus = 'Success';
      this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = false;
      this.paymentTable.find(o => o.payId == this.currentPayId)['processedCNPCC'] = stripeRes;

      if ([EPaymentModes.CreditCard, EPaymentModes.HostedPage, EPaymentModes.CardOnfile].includes(paymentMode)) {
        if (paymentMode == EPaymentModes.CreditCard && stripeRes.IsInteracPayment) {
          let requestgatewaydetailsObj = JSON.parse(this.requestgatewaydetails);
          requestgatewaydetailsObj['IsInteracPayment'] = stripeRes.IsInteracPayment;
          this.requestgatewaydetails = JSON.stringify(requestgatewaydetailsObj);
        }
        const stripeCCModel = {
          Amount: parseFloat(stripeRes.Amount) / 100,
          Autopay: false,
          PaymentModeId: paymentMode,
          AutoCcProcessingDay: 0,
          CreditCardNumber: `XXXXXXXXXXX${stripeRes.CreditCardNumber}`,
          CreditCardType: this.paymentService.openEdgeCardType(stripeRes.CardBrand),
          NameonCard: stripeRes.CreditHolderName,
          CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(stripeRes.ExpiryMonth, 10)),
          CreditCardExpiryYear: parseInt(stripeRes.ExpiryYear, 10),
          CreditCardBillingAddress: stripeRes?.BillingDetails?.Address ? ((stripeRes.BillingDetails.Address.Line1 ?? '') + ',' + (stripeRes.BillingDetails.Address.Line2 ?? '')).trim().slice(0, 50) : '',
          CreditCardBillingZip: stripeRes?.BillingDetails?.Address?.PostalCode ?? "",
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: stripeRes.ChargeId,
          Key: stripeRes.PaymentIntentId,
          ResponseCode: stripeRes.ResponseCode,
          Reason: stripeRes?.Reason ?? '',
          PaymentAccountid: paymentMode == EPaymentModes.CardOnfile && stripeRes.PaymentMethodId ? stripeRes.PaymentMethodId : "",
          CcInfoPurged: false,
          DebitCardPayment: stripeRes.CardType == 'debit',
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Processed,
          OrderId: orderId,
          EmvReceiptText: stripeRes.ReceiptUrl,
          TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
          TenantId: this.customerInfo.VendorIdd ? this.customerInfo.VendorIdd : null,
          MarketId: this.MarketId,
          GatewayDetails: this.requestgatewaydetails,
          PaymentMethodId: stripeRes.PaymentMethodId,
          CustomerId: stripeRes?.CustomerId ?? '',
          GatewayId: this.paymentGateway
        };
        this.paymentTable.find(o => o.payId == this.currentPayId)['processedStripeCC'] = stripeCCModel;
        this.MASKEDCARDNUMBER = stripeCCModel.CreditCardNumber;

        //if ([EPaymentOrigin.Rental, EPaymentOrigin.Transfer, EPaymentOrigin.ReInstate, EPaymentOrigin.MakePayment].includes(this.processPayment.Type) && this.paymentTable.find(ele => ele.payId == payId && ele.EnableAutopayOrCardOnFile != 'cancel')) {
        //  this.setUpStripeAutopayModel(stripeCCModel, paymentMode, payId);
        //}
        let GatewayResponse = JSON.parse(stripeRes.GatewayResponse);
        let CCTModel;
        const receiptText = stripeRes.ReceiptUrl //jsonResp.RESULT.RECEIPTTEXT;
        const entryMethodMatch = receiptText.match(/Entry Method\s+([^\n]+)/);
        const tempCCModel = {
          VerifoneId: this.verifoneRecordId,
          Amount: stripeCCModel.Amount,
          CreditCardNumber: stripeCCModel.CreditCardNumber,
          ResponseCode: stripeCCModel.ResponseCode ? stripeCCModel.ResponseCode : '00',
          ResponseMessage: "Approval",
          Card: this.keyedInTransaction ? "Credit Card" : "",
          TransactionDateTime: new Date(),
          TransactionTypeId: this.TransactionType,
          OrderId: stripeCCModel.OrderId,
          VendorId: this.VendorId,
          ProcessStatus: "Completed",
          ApprovalCode: stripeRes.ChargeId,
          PaymentTransactionTypeId: stripeCCModel.Key,
          PaymentTransactionType: "Payment Purchase",
          CreditCardType: stripeRes.CardBrand,
          EntryLegend: this.keyedInTransaction ? "CNP" : GatewayResponse.read_method,
          EntryMethod: entryMethodMatch ? entryMethodMatch[1].trim() : '',
          ReceiptResponse: JSON.stringify(stripeRes),
          shopperRequest: this.shopperRequest
        };


        CCTModel = Object.assign(tempCCModel);
        const res = await lastValueFrom(
          this.paymentService.saveVerifoneUnSaved(CCTModel)
        );
        if ([EPaymentModes.HostedPage, EPaymentModes.CreditCard].includes(paymentMode)) {
          if (res) {
            this.capturePaymentIntent(this.MarketId, stripeCCModel.Key, orderId);
          }
        }
        this.gotoPaymentSuccess(stripeCCModel.Amount);
      } else if ([EPaymentModes.DirectDebitEFTOnFile, EPaymentModes.ACHOnFile].includes(paymentMode)) {
        //const stripeACHModel = {
        //  APPROVEDAMOUNT: (stripeRes.Amount) / 100,
        //  CHECKNUMBER: '',
        //  TRANSACTIONID: stripeRes.ChargeId,
        //  RESPONSECODE: stripeRes.ResponseCode,
        //  RESPONSEDESCRIPTION: stripeRes?.Reason ?? "",
        //  ACCOUNT: this.accountNumber,
        //  ROUTINGNUMBER: this.routingNumber,
        //  RECEIPTTEXT: '',
        //  ACCOUNTYPE: '',
        //  PaymentIntentId: stripeRes.PaymentIntentId,
        //  PaymentAccountId: this.paymentAccountId,
        //  PaymentMethod: this.PaymentMethod,
        //  PaymentAccountid: paymentMode == EPaymentModes.CardOnfile && stripeRes.PaymentMethodId ? stripeRes.PaymentMethodId : "",
        //  IsStripeEFT: (paymentMode == EPaymentModes.ACHOnFile) ? false : true,
        //  CustomerId: stripeRes?.CustomerId ?? ''
        //}
        //this.paymentTable.find(o => o.payId == this.currentPayId)['processedACH'] = stripeACHModel;
      }
      else if ([EPaymentModes.ACH, EPaymentModes.DirectDebitEFT].includes(paymentMode)) {
        //const stripeModel = {
        //  APPROVEDAMOUNT: parseFloat(stripeRes.Amount) / 100,
        //  CHECKNUMBER: stripeRes?.InstitutionNumber ?? '',
        //  TRANSACTIONID: stripeRes.ChargeId,
        //  RESPONSECODE: stripeRes.ResponseCode,
        //  RESPONSEDESCRIPTION: stripeRes?.Reason ?? "",
        //  ACCOUNT: stripeRes.AccountNumber,
        //  ROUTINGNUMBER: paymentMode == EPaymentModes.DirectDebitEFT ? stripeRes.TransitNumber : stripeRes.RoutingNumber,
        //  PaymentIntentId: stripeRes.PaymentIntentId,
        //  PaymentAccountId: stripeRes.PaymentMethodId,
        //  IsStripeEFT: paymentMode == EPaymentModes.DirectDebitEFT ? true : false,
        //  CustomerId: stripeRes?.CustomerId ?? ''
        //}
        //this.paymentTable.find(o => o.payId == this.currentPayId)['processedACH'] = stripeModel;
        //if ([EPaymentOrigin.Rental, EPaymentOrigin.Transfer, EPaymentOrigin.ReInstate, EPaymentOrigin.MakePayment].includes(this.processPayment.Type) && this.paymentTable.find(ele => ele.payId == payId && ele.EnableAutopayOrCardOnFile != 'cancel')) {
        //  this.setUpStripeAutopayModel(stripeModel, paymentMode, payId);
        //}
      }
      //this.gotoPaymentSuccess(this.popUpPayment, (parseFloat(stripeRes.Amount) / 100).toFixed(2));
    } else {
      this.paymentSuccessFul = false;
      this.paymentProcessing = false;
      this.payStatus = 'Failed';
      this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
      stripeRes['PaymentModeId'] = paymentMode;
      let CCTModel;
      const tempCCModel = {
        VerifoneId: this.verifoneRecordId,
        CreditCardNumber: stripeRes.CreditCardNumber,
        CardType: stripeRes.CardType,
        ResponseCode: stripeRes.ResponseCode,
        ResponseMessage: stripeRes?.Reason ?? '',
        Card: this.keyedInTransaction ? "Credit Card" : "",
        TransactionDateTime: new Date(),
        OrderId: orderId,
        VendorId: this.VendorId,
        ProcessStatus: "Failed",
        PaymentTransactionTypeId: stripeRes.PaymentIntentId,
        CreditCardType: this.paymentService.openEdgeCardType(stripeRes.CardBrand),
        shopperRequest: this.shopperRequest
      };
      this.paymentFailReason = stripeRes?.Reason ?? '';
      CCTModel = Object.assign(tempCCModel);
      this.paymentService.saveVerifoneUnSaved(CCTModel).subscribe((res: any) => {
      });
      this.MASKEDCARDNUMBER = stripeRes.CreditCardNumber;

      const failReasonText = this.paymentFailReason
        ? this.escapeHtml(this.paymentFailReason)
        : 'Transaction Time Out!';

      Swal.fire({
        title: $localize`Payment Failed!`,
        html: `<h5>Uh-oh! We Were Unable To Process Your Payment</h5>
                <p>${failReasonText}</p>`,
        icon: "error",
        confirmButtonText: $localize`Ok`,
      }).then(result => {
        if (result.value) {
          this.gotoPaymentSuccess(0);
        }
      });
    }
  }

  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  getExpiryMonthValue(expiryMonth) {
    let tempMonth = 263;
    if (expiryMonth) {
      if (expiryMonth > 0 && expiryMonth < 13) {
        expiryMonth = tempMonth + expiryMonth;
      } else if (expiryMonth > 263 && expiryMonth < 276) {
        expiryMonth = expiryMonth;
      } else {
        expiryMonth = 264;
      }
    } else {
      expiryMonth = 264;
    }
    return expiryMonth;
  }


  gotoPaymentSuccess(amount) {
    this.paymentStarted = true;
    this.tillNowPaid += parseFloat(amount);
    if (this.paymentSuccessFul) {
      this.paymentTable.find(o => o.payId === this.currentPayId).payComplete = true;
    }
    if (this.paymentSuccessFul) {
      var obj = {
        VerifoneId: this.verifoneRecordId,
        PaymentSuccess: this.paymentSuccessFul,
        OrderId: this.paymentTable.find(o => o.payId == this.currentPayId).orderId,
        CardNumber: this.MASKEDCARDNUMBER
      }
      this.PaymentResponse.emit(obj);
    }
    else {
      var objFailure = {
        VerifoneId: this.verifoneRecordId,
        PaymentSuccess: this.paymentSuccessFul,
        OrderId: this.paymentTable.find(o => o.payId == this.currentPayId).orderId
      }
      this.PaymentResponse.emit(objFailure);
    }
  }

  voidPaymentTransaction(verifoneRecordId, credentials) {
    this.loaderIcon = Promise.resolve(true);
    const payId = 1;
    this.currentPayId = payId;
    this.paymentService.GetVerifoneUnSavedDate(verifoneRecordId, this.shopperRequest).subscribe((res: any) => {
      let CCTModel = this.generateIntialCCT(this.CCAmount, 1, 1, 1, null, null, null, res.OrderId);
      this.paymentService.saveVerifoneUnSaved(CCTModel).subscribe((cctRes) => {
        if (cctRes.Success) {
          this.verifoneRecordId = cctRes.Id;
          const paymentAmount = this.RefundAmount > 0 ? this.RefundAmount : res.Amount;
          const orderId = res.OrderId;
          const DebitOrderId = cctRes.OrderId;
          const OpenEdgeTransType = res.TransactionTypeId;
          if (credentials) {
            let TransactionCardType = res.Card;
            var paymentTransactionTypeId = res.PaymentTransactionTypeId;
            var paymentReturnType = "CREDITVOID";
            if (this.RefundAmount > 0 || this.ForceCreditReturn == true) {
              paymentReturnType = "CREDITRETURN";
            }
            //if (TransactionCardType == 'Credit Card') {
            this.paymentService.GetChargesDetailsByIntentId(paymentTransactionTypeId, this.MarketId, "").subscribe(async (CharDetailres: any) => {
              if (CharDetailres.Success) {
                let Amt = Math.round(paymentAmount * 100);
                const refundPaymentModel = {
                  PaymentIntentId: CharDetailres.PaymentIntentId,
                  ChargeId: CharDetailres.ChargeId,
                  Amount: Amt,
                  MarketId: this.MarketId,
                  OrderId: orderId,
                  GatewayDetails: null
                }
                this.paymentService.refundPaymentIntent(refundPaymentModel).subscribe((cancelOrRefundRes: any) => {
                  if (cancelOrRefundRes) {
                    const tempCCModel = {
                      VerifoneId: this.verifoneRecordId,
                      Amount: this.RefundAmount > 0 ? this.RefundAmount : parseFloat(CharDetailres.Amount) / 100,
                      VendorId: this.VendorId,
                      ProcessStatus: "Completed",
                      CreditCardNumber: `XXXXXXXXXXX${CharDetailres.CreditCardNumber}`,
                      ResponseCode: cancelOrRefundRes.ResponseCode ? cancelOrRefundRes.ResponseCode : "00",
                      ResponseMessage: cancelOrRefundRes.Reason,
                      OrderId: orderId,
                      TransactionDateTime: new Date(),
                      TransactionTypeId: OpenEdgeTransType != '' ? OpenEdgeTransType : 'credit',
                      ReceiptResponse: JSON.stringify(cancelOrRefundRes),
                      Card: TransactionCardType,
                      CreditCardType: CharDetailres.CardBrand,
                      PaymentTransactionTypeId: cancelOrRefundRes.RefundIntentId,
                      ApprovalCode: cancelOrRefundRes.ChargeId,
                      PaymentTransactionType: paymentReturnType,
                      shopperRequest: this.shopperRequest
                    };
                    const CCTModel = Object.assign(tempCCModel);
                    this.paymentService.saveVerifoneUnSaved(CCTModel).subscribe((res: any) => {
                      if (!res.Success) {
                        this.toastr.warning('Verifone table failed', 'Info', this.toasterConfig);
                        this.loaderIcon = Promise.resolve(false);
                      }
                    });
                    this.initiatedVoidCC = false;
                    this.loaderIcon = Promise.resolve(false);
                  }
                  let toastrMsg = "";
                  let cancelOrRefundResStatus = false;
                  if (cancelOrRefundRes.Status == "canceled") {
                    toastrMsg = "Payment Intent has been cancelled!";
                    cancelOrRefundResStatus = true;
                  }
                  if (cancelOrRefundRes.Status == "succeeded" || cancelOrRefundRes.Status == "pending") {
                    toastrMsg = "Credit card payment reversed successfully";
                    cancelOrRefundResStatus = true;
                  }
                  var obj = {
                    VerifoneId: this.verifoneRecordId,
                    PaymentSuccess: cancelOrRefundResStatus,
                    OrderId: orderId,
                    CardNumber: `XXXXXXXXXXX${CharDetailres.CreditCardNumber}`
                  }
                  this.toastr.info(toastrMsg, 'Info', this.toasterConfig);
                  this.PaymentResponse.emit(obj);
                  this.loaderIcon = Promise.resolve(false);
                }, err => {
                  this.loaderIcon = Promise.resolve(false);
                  CharDetailres.ResponseCode = "";
                  CharDetailres.Reason = "Failed to VoidorRefundPaymentTransaction() -- RefundPaymentIntent";
                  CharDetailres['errprResponse'] = JSON.stringify(err);
                  this.saveStripeCCTransactionFail(CharDetailres, "", orderId, EPaymentTransactionType.Reversal_Refund);
                });
              }
              else {
                this.loaderIcon = Promise.resolve(false);
                let errprResponse = {
                  Reason: CharDetailres.Reason,
                  errprResponse: JSON.stringify(CharDetailres),
                  ResponseCode: ""
                }
                this.saveStripeCCTransactionFail(errprResponse, "", orderId, EPaymentTransactionType.Reversal_Refund);
              }
            }, err => {
              this.loaderIcon = Promise.resolve(false);
              let errprResponse = {
                Reason: err?.error?.error ? err.error.error : 'Failed to Get Charges Details By IntentId',
                errprResponse: JSON.stringify(err),
                ResponseCode: ""
              }
              this.saveStripeCCTransactionFail(errprResponse, "", orderId, EPaymentTransactionType.Reversal_Refund);
            });
            //}
          }
        }
      }, () => this.voidPaymentRequestFailed(res.OrderId));
    }, () => this.voidPaymentRequestFailed(null));
  }

  // The refund could not start (e.g. network down): stop the loader and report failure so the caller can retry
  private voidPaymentRequestFailed(orderId) {
    this.loaderIcon = Promise.resolve(false);
    this.PaymentResponse.emit({
      VerifoneId: this.verifoneRecordId,
      PaymentSuccess: false,
      OrderId: orderId
    });
  }

  capturePaymentIntent(MarketId, paymentIntentId, orderId) {
    this.paymentService.CapturePaymentIntent(MarketId, paymentIntentId).subscribe((response: any) => {
      if (response.Status == "succeeded") {
        //this.paymentService.updateCreditCardPaymentReason(orderId, response.Status).subscribe(() => { })
      }
    }, () => {
    });
  }


  async stripeTerminalPayment() {
    let paymentTrnsId = ""; //this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    let payId = this.currentPayId;
    let stripePaymentTable = this.paymentTable.find(o => o.payId == this.currentPayId);
    if (this.credentials && this.credentials.DeviceSettings && this.credentials.DeviceSettings.length > 0 && stripePaymentTable.TerminalDeviceId) {
      //if (this.credentials) {
      this.paymentMaxWaitTime = 2;//this.paymentMaxWaitTime != undefined ? this.paymentMaxWaitTime : 2;
      this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = false;
      this.paymentInProgress = true;
      //this.isOpenEdgeEMVCompleted = false;
      //this.isOpenEdgeEMVCompleted = false;
      this.stripeTerminalDeviceId = this.paymentTable.find(o => o.payId === this.currentPayId).TerminalDeviceId;//stripePaymentTable.TerminalDeviceId
      //this.requestGatewaydetails();
      const customerObj = {
        Name: this.customerInfo.FullName,
        Email: this.customerInfo.Email,
        Phone: this.customerInfo.CellPhoneNumber,
      };

      // Connect first so the server can send this payment's response to this browser only
      const signalRConnectionId = await this.signalRService.startConnection(this.baseUrl);
      this.signalRService.addStripeResponseListener("ReceivePaymentUpdate");

      const obj = {
        Amount: parseFloat(this.CCAmount),
        OrderId: this.paymentTable.find(o => o.payId === this.currentPayId).orderId,
        SignalRConnectionId: signalRConnectionId,
        DeviceId: this.stripeTerminalDeviceId,//stripePaymentTable.TerminalDeviceId,
        TransactionType: 3,//this.getLovTransactionType(),
        TenantId: this.customerInfo.VendorIdd,
        StripePaymentType: "SALE",
        Name: customerObj.Name,
        Email: customerObj.Email,
        Phone: customerObj.Phone,
        MarketId: this.MarketId,
        EnableAutopayOrCardOnFile: "cancel",//stripePaymentTable.EnableAutopayOrCardOnFile,
        PaymentTransactionType: 2,//this.getTransactionType()
      };

      this.paymentService.processTerminalPayment(obj).subscribe((stripeRes) => {
        this.showLoaderMesage = false;
        //this.isTDEmv.isTransactionWaitTime = this.stripeLoader.isStripeterminal = true;
        //this.loaderIcon = Promise.resolve(true);
        this.paymentTable.find(o => o.payId === payId).stripePaymentIntentId = stripeRes.PaymentIntentId
        if (stripeRes) {
          if (!stripeRes.Success) {
            this.signalRService.stopConnection();
            this.isStripeTerminalPay = stripeRes.Reason == 'Another Transaction is in Progress';
            this.stripeResponse = stripeRes;
            this.saveStripeCCTransactionFail(stripeRes, "", stripePaymentTable.orderId, EPaymentModes.CreditCard);
          } else {
            this.stripeResponseSubscription = this.signalRService.stripeResponse$.subscribe((response: any) => {
              this.signalRService.stopConnection();
              this.unSubscribeSignalRSubscribe();
              //this.stripeLoader.isStripeterminal = false;
              let resultResponse = JSON.parse(response);
              this.stripeResponse = resultResponse;
              //this.isTDEmv.isTransactionWaitTime = false;
              if (resultResponse.Success && resultResponse.OrderId == stripePaymentTable.orderId && obj.EnableAutopayOrCardOnFile != 'cancel' && this.autopayLinledUnitList.length > 0) {
                this.loaderIcon = Promise.resolve(false);
                //this.linkedAutopayModalRef = this.modalService.show(this.linkedAutopay, { class: 'modal-dialog-centered ', backdrop: 'static', keyboard: false });
              } else if (resultResponse.Success && resultResponse.OrderId != stripePaymentTable.orderId) {
                stripeRes.Reason = `Another Transaction is in progress - OrderId not matching - ${stripePaymentTable.uniqueTransId}`;
                this.saveStripeCCTransactionFail(stripeRes, paymentTrnsId, stripePaymentTable.orderId, EPaymentModes.CreditCard);
              } else if (resultResponse.OrderId == stripePaymentTable.orderId && !this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted) {
                this.GetStripeResponse(resultResponse, payId, stripePaymentTable.orderId, paymentTrnsId, EPaymentModes.CreditCard);
              }
            }, () => {
              this.loaderIcon = Promise.resolve(false);
              this.saveStripeCCTransactionFail(stripeRes, paymentTrnsId, stripePaymentTable.orderId, EPaymentModes.CreditCard);
            });
          }
        }
      }, err => {
        this.signalRService.stopConnection();
        this.loaderIcon = Promise.resolve(false);
        const errprResponse = this.handelStripeError(err);
        this.saveStripeCCTransactionFail(errprResponse, paymentTrnsId, stripePaymentTable.orderId, EPaymentModes.CreditCard);
      });

      let countdown = (10000 * 6 * this.paymentMaxWaitTime) / 1000;
      // Initial display
      this.paymentCountdown = this.formatTime(countdown);

      this.countdownTimerId = setInterval(() => {

        this.paymentCountdown = this.formatTime(countdown);
        this.CountdownS = countdown;
        console.log(`Payment timeout in ${this.paymentCountdown}`);

        countdown--;

        if (countdown < 0) {
          clearInterval(this.countdownTimerId);
          this.finalizePendingTerminalPayment(payId, stripePaymentTable);
        }
        else {
          var payment = this.paymentTable.find(o => o.payId === payId);
          if (payment.payFailed == true || payment.isOpenEdgePaymentCompleted == true) {
            clearInterval(this.countdownTimerId);
          }
        }
      }, 1000);
    } else {
      this.loaderIcon = Promise.resolve(false);
      this.toastr.warning('Please ask Administrator to configure Device Setup', 'Device Setup required', this.toasterConfig);
      const stripeRes = {
        Reason: "Device Setup required!"
      }
      Swal.fire({
        title: $localize`Payment Failed!`,
        html: `<h5>Uh-oh! We Were Unable To Process Your Payment</h5><p>` + stripeRes.Reason + `</p>`,
        icon: "error", confirmButtonText: $localize`Ok`,
      }).then(result => { if (result.value) { this.gotoPaymentSuccess(0); } });
    }
  }

  finalizePendingTerminalPayment(payId, stripePaymentTable, checkTerminalStatus: boolean = false) {
    const payment = this.paymentTable.find(o => o.payId === payId);
    if (
      payment &&
      !payment.isOpenEdgePaymentCompleted &&
      payment.uniqueTransId === stripePaymentTable.uniqueTransId
    ) {
      if (!checkTerminalStatus) {
        // Genuine 2-minute timeout: give up for good, cancel the terminal action/intent.
        this.unSubscribeSignalRSubscribe();
        payment.isOpenEdgePaymentCompleted = true;
      }
      // A manual "Check Status" click just peeks at the current state - don't finalize or
      // stop listening for the real SignalR result until we know it isn't still pending.

      const paymentMode = this.paymentTable.find(o => o.payId === this.currentPayId)?.payModeId;

      if (payment.stripePaymentIntentId) {
        const obj = {
          PaymentIntentId: payment.stripePaymentIntentId,
          MarketId: this.MarketId,
          PayId: payId,
          OrderId: stripePaymentTable.orderId,
          PaymentTrnsId: paymentMode,
          PaymentModeId: EPaymentModes.CreditCard
        };

        this.callGetStripeCharge(obj, checkTerminalStatus);
      } else {
        this.loaderIcon = Promise.resolve(false);
      }
    }
  }

  onCheckPaymentStatus() {
    const payId = this.currentPayId;
    const stripePaymentTable = this.paymentTable.find(o => o.payId === payId);
    if (!stripePaymentTable || stripePaymentTable.isOpenEdgePaymentCompleted || this.checkingPaymentStatus) {
      return;
    }
    this.checkingPaymentStatus = true;
    if (this.countdownTimerId) {
      clearInterval(this.countdownTimerId);
    }
    this.loaderIcon = Promise.resolve(true);
    this.finalizePendingTerminalPayment(payId, stripePaymentTable, true);
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  unSubscribeSignalRSubscribe() {
    if (this.stripeResponseSubscription != null) {
      this.stripeResponseSubscription.unsubscribe();
      this.stripeResponseSubscription = null;
    }
  }

  handelStripeError(err) {
    let errorMessage = err?.error?.details ? err.error.details : err?.error?.error ? err.error.error : err?.error?.detail ? err.error.detail : "Declined!";
    const obj = {
      Reason: errorMessage,
      ResponseCode: err?.error?.status ?? '',
      Success: false
    }
    return obj;
  }

  saveStripeCCTransactionFail(stripFailedResponse, paymentTrnsId, orderId, paymentMode) {
    var Reason = "";
    var ResponseCode = "";
    var ReceiptResponse = "";

    if (stripFailedResponse.Reason !== "") {
      Reason = stripFailedResponse.Reason;
      ResponseCode = stripFailedResponse.ResponseCode;
      ReceiptResponse = stripFailedResponse.errprResponse;
    }
    else {
      let errprResponse = this.handelStripeError(stripFailedResponse);
      Reason = errprResponse.Reason;
      ResponseCode = errprResponse.ResponseCode;
      ReceiptResponse = JSON.stringify(stripFailedResponse);
    }
    this.paymentSuccessFul = false;
    this.paymentProcessing = false;
    this.payStatus = 'Failed';
    this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
    stripFailedResponse['PaymentModeId'] = paymentMode;
    let CCTModel;
    const tempCCModel = {
      VerifoneId: this.verifoneRecordId,
      CreditCardNumber: stripFailedResponse.CreditCardNumber,
      CardType: stripFailedResponse.CardType,
      ResponseCode: ResponseCode ?? '',
      ResponseMessage: Reason ?? '',
      ReceiptResponse: ReceiptResponse,
      Card: this.keyedInTransaction ? "Credit Card" : "",
      TransactionDateTime: new Date(),
      OrderId: orderId,
      VendorId: this.VendorId,
      ProcessStatus: "Failed",
      PaymentTransactionTypeId: stripFailedResponse.PaymentIntentId,
      ApprovalCode: stripFailedResponse.ChargeId,
      CreditCardType: stripFailedResponse.CardBrand,
      shopperRequest: this.shopperRequest
    };
    CCTModel = Object.assign(tempCCModel);
    this.paymentService.saveVerifoneUnSaved(CCTModel).subscribe((res: any) => {
      this.loaderIcon = Promise.resolve(false);
    });

    this.loaderIcon = Promise.resolve(false);
    this.gotoPaymentSuccess(0);
    Swal.fire({
      title: $localize`Payment Failed!`,
      html: `<h5>Uh-oh! We Were Unable To Process Your Payment</h5>
                <p>`+ stripFailedResponse.Reason + `</p>`,
      icon: "error", confirmButtonText: $localize`Ok`,
    });
  }

  stripeMethod(key, ClientSecret) {
    this.stripe3ds.handleNextAction({
      clientSecret: ClientSecret
    }).then(({ paymentIntent, error }) => {
      if (error) {
        this.elements?.getElement('payment')?.unmount();
        this.elements?.getElement('address')?.unmount();
        this.elements = null;
        this.stripe3ds = null;
        const form = document.querySelector('#payment-form');
        if (form) form.remove();
        this.GetChargesDetailsByIntentId();
      } else {
        if (paymentIntent.status === 'succeeded' || paymentIntent.status === 'requires_capture') {
          this.GetChargesDetailsByIntentId();
        }
      }
    });
  }
}
